import React from 'react';
import './../index.css';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

const styleAuthModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  height: 'auto',
  paddingBottom: '10%',
  bgcolor: '#151616',
  color: '#6ecabe',
  border: '2px solid #151616',
  borderRadius: '3%',
  boxShadow: 24,
  textAlign: 'center',
  p: 4,
};

export default function PhotoModal(props) {
  return (
    <div>
      <Modal
        open={props.photoModalOpen && true}
        onClose={props.handlePhotoModalOpen}
        aria-labelledby="auth-modal"
      >
        <Box sx={styleAuthModal}>
          <Box
            sx={{
              width: '90%'
            }}>
            <img
              className='image-modal'
              src={props.photoURL}
              alt={"doc.id"}
              loading="lazy"
            />
          </Box>
        </Box>
      </Modal>
    </div>
  )
}